import { useEffect } from 'react';
import { useOidc } from '@revenuewell/logic-oidc';

export function SignInRedirectCallback() {
    const { signinRedirectCallback } = useOidc();

    useEffect(() => {
        signinRedirectCallback()
    }, [])

    return null
}
